export default __webpack_public_path__ + "static/media/rickandmorty.c2f3fb0e.png";